import { GroupItem } from '../../../../../typings'
import { HOME_PATH } from '../../../constants'
import { GetContentFunction } from '../../../hooks/useLocalizedContent'
import { AppDispatch } from '../../../store'
import { showGlobalToast } from '../../../store/slices/globalToastSlice'
import {
  setCreateGroupFlow,
  toggleCreateSuccess,
} from '../../../store/slices/sheetsSlice'

export const resumeCreate = () => (dispatch: AppDispatch) => {
  // We need to replace the history like this because using `navigate()` reloads and closes sheets
  history.replaceState({}, '', HOME_PATH)

  // Show the success screen
  dispatch(toggleCreateSuccess())

  // Open the create pool sheet that contains the success screen
  dispatch(setCreateGroupFlow({ toggleCreateGroupFlow: true }))
}

export const resumeUpdate =
  (pool: GroupItem, getContent: GetContentFunction) =>
  (dispatch: AppDispatch) => {
    // We need to replace the history like this because using `navigate()` reloads and closes sheets
    const redirectUrl = pool?.id ? `${HOME_PATH}/${pool.id}` : HOME_PATH
    history.replaceState({}, '', redirectUrl)

    if (getContent) {
      dispatch(
        showGlobalToast({
          isSuccess: true,
          message: getContent('update.succesMessage'),
        }),
      )
    }
  }
